<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Historial</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-12">
            <div class="form-inline">
              <label>
                <input v-model="form.tipoFecha" type="radio" value="T" />
                <span>A la fecha</span>
              </label>
              <label>
                <input v-model="form.tipoFecha" type="radio" value="P" />
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker id="desde" v-model="form.fechaDesde" locale="es" only-date no-label
                    button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                    label="Seleccione fecha..." />
                  <label>Desde:</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker id="desde" v-model="form.fechaHasta" locale="es" only-date no-label
                    button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                    label="Seleccione fecha..." />
                  <label>Hasta:</label>
                </div>
              </div>
              <button type="button" @click="consultar" class="btn-info btn--bigger ml-auto">
                <i class="fa fa-search"></i><span>Consultar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-xs-12">
        <k-table 
          @descargar="descargar"
          :buscarButton="false" 
          :mostrarTotales="false" 
          :editButton="false"
          :deleteButton="false" 
          :filterStatus="false" 
          :createButton="false" 
          :path="path" 
          :columns="columnas"
          :params="form" 
          :buttons="[
            {
              event: 'descargar',
              icon: 'fa-download',
              class: 'btn-success btn--text'
            }
          ]"
          ref="listaHistoricos">
        </k-table>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    tipoReporte: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function () {
    return {
      // moment: moment,
      path: url + '/gen-reporte-historico',
      form: {
        tipoFecha: 'T',
        fechaDesde: '',
        fechaHasta: '',
        tipo_reporte: this.tipoReporte
      },
      columnas: [
        {
          display: 'Usuario',
          value: 'nombre_usuario'
        },
        {
          display: 'Bodega',
          value: 'descripcion_bodega'
        },
        {
          display: 'Nombre',
          value: 'nombre_archivo'
        },
        {
          display: 'Fecha',
          value: 'created_at'
        }
      ]
    }
  },
  methods: {
    consultar: function () {
      this.$refs.listaHistoricos.loadRows();
    },
    descargar: function (row) {
      const {id} = row;
      let urlApi = `${url}/descargar-historico/${id}`;
      window.open(urlApi, '_blank');
    }
  },
  mounted: function () {
    //Seteando fechas por defecto
    let desde = new Date();
    desde.setDate(desde.getDate() - 6);
    let hasta = new Date();
    this.form.fechaDesde = moment(desde).format("YYYY-MM-DD");
    this.form.fechaHasta = moment(hasta).format("YYYY-MM-DD");
  }
}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/ReportesHistoricosExcel.vue